import { render, staticRenderFns } from "./dialogInfo.vue?vue&type=template&id=2451aafc&"
import script from "./dialogInfo.vue?vue&type=script&lang=js&"
export * from "./dialogInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogInfo.vue?vue&type=style&index=0&id=2451aafc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports